export default __webpack_public_path__ + "static/media/005-fan.219fb757.svg";